<template>
  <div>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="flex h-full" style="cursor: pointer;">
                <div :class="[(currentRoute === 'forms') ? 'menu-item-active' : 'menu-item']" @click="select('forms')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Company Information</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'attachments') ? 'menu-item-active' : 'menu-item']" @click="select('attachments')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Attachments</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'messages') ? 'menu-item-active' : 'menu-item']" @click="select('messages')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Messages</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <CompanyForms v-if="currentRoute === 'forms'" :task="task"/>
              <CompanyFormFiles v-if="currentRoute === 'attachments'" :task="task"/>
              <CompanyMessages v-if="currentRoute === 'messages'" :task="task"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import CompanyForms from "@/views/home/services/incorporation/task/CompanyForms";
import CompanyFormFiles from "@/views/home/services/incorporation/task/CompanyFormFiles";
import CompanyMessages from "@/views/home/services/incorporation/task/CompanyMessages";
export default {
  name: "CompanyFormDetails",
  components: {CompanyMessages, CompanyFormFiles, CompanyForms},
  props:{
    task:Object
  },
  data(){
    return{
      currentRoute: "forms",
    }
  },
  methods:{
    select(route){
      this.currentRoute = route
    },
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>